import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { task, all } from "ember-concurrency";
import { service } from "@ember/service";

export default class ModalsApiKeyCreate extends Component {
  @service modal;

  @tracked description = "";
  @tracked projectsGroupedByOrganization = [];
  @tracked selectedProject;

  get organizations() {
    return this.args.params.organizations;
  }

  get task() {
    return this.args.params.task;
  }

  submitTask = task(async () => {
    await this.task.perform(this.selectedProject, this.description);
    this.modal.close();
  });

  onFormChange = ({ description, project }) => {
    this.description = description;
    this.selectedProject = this.projectsGroupedByOrganization
      .flatMap((organization) => organization.options)
      .find((proj) => proj.id === project);
  };

  loadData = task(async () => {
    this.projectsGroupedByOrganization = await all(
      this.organizations.map(async (organization) => ({
        label: `${organization.name} (#${organization.id})`,
        options: (await organization.projects).filter((project) => !project.locked),
      })),
    );
  });
}
